import {
	useGetIdentity,
	Toolbar,
	Edit,
	SimpleForm,
	TextInput,
	TextField,
	ImageInput,
	Labeled,
	SaveButton,
	ReferenceManyField,
	Datagrid,
	DeleteButton,
	DateField,
	useRecordContext,
	usePermissions
} from "react-admin";
import makeStyles from "@mui/styles/makeStyles";
import { Avatar, Paper } from "@mui/material";
import get from "lodash/get";
import classnames from "classnames";
import APIKeyQuickCreateButton from "./CreateAPIKeyDialog";
import PasswordChangeDialog from "./PasswordChangeDialog";
import { useUpdate } from "react-admin";
import { useNotify } from "react-admin";


const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiTextField-root": {
			margin: theme.spacing(1),
			width: 200,
		},
	},
	inline: {
		display: "inline-block",
	},
	marginLeft: {
		marginLeft: "2em",
	},
	width200: {
		width: 200,
		float: "right",
	},
	drop: {
		"& div div": {
			textAlign: "left",
		},
	},
}));

const ProfileToolbar = () => (
	<Toolbar sx={{ display: 'flex', flexDirection: 'row', gap: '1em', justifyContent: 'space-between' }}>
		<SaveButton label="Save" redirect={false} submitOnEnter={true} />
		<PasswordChangeDialog />
	</Toolbar>
);

const B64Preview = (props) => {
	const { source, elStyle, title } = props;
	const record = useRecordContext();
	if (!record[source]) {
		return <Avatar alt={title} title={title} src={record} style={elStyle} />;
	} else {
		return (
			<Avatar
				alt={record.title}
				title={record.title}
				src={record.src}
				style={elStyle}
			/>
		);
	}
};

const FutureDateField = (props) => {
	const { source } = props;
	const record = useRecordContext(props);
	const newDate = new Date(get(record, source));
	newDate.setFullYear(newDate.getFullYear() + 3);
	return (
		<span>
			{newDate.getMonth() +
				1 +
				"/" +
				newDate.getDate() +
				"/" +
				newDate.getFullYear()}
		</span>
	);
};

const UserProfile = (props) => {
	const record = useRecordContext();
	const classes = useStyles();
	const { identity, loading: identityLoading } = useGetIdentity();
	const { permissions } = usePermissions();
	const [update] = useUpdate();
	const notify = useNotify();

	const handleSubmit = (data) => {
		const {
			password,
			password_reset_token,
			registration_token,
			...rest
		} = data;
		update(
			"profile",
			{ id: data.id, data: rest },
			{
				onSuccess: () => {
					notify("Profile updated successfully!");
				},
				onError: (error) => {
					notify(`Error updating profile: ${error}`)
				}
			}
		);
	}
	console.log("user profile record", record);
	if (identityLoading) return <div>Loading...</div>;

	return (
		<Edit
			id={identity?.id}
			resource="profile"
			basePath="/user_profile"
			redirect={false}
			title="Edit Profile"
			style={{ height: "100vh" }}
			{...props}
		>
			<SimpleForm
				toolbar={<ProfileToolbar />}
				onSubmit={handleSubmit}
			>
				<TextInput source="name" formClassName={classnames(classes.inline)} />
				<TextInput disabled source="email" />
				<TextInput disabled source="role" />

                <div style={{ display: 'flex', flexFlow: 'row wrap', justifyContent: 'flex-start', gap: '1em'}}>
                    <Paper
                        sx={{
                            padding: '1em',
                        }}
                    >
                        <ImageInput
                            source="user_avatar"
                            label="Avatar"
                            multiple={false}
                            accept="image/*"
                            placeholder="Change Avatar"
                            style={{ marginBottom: "1em" }}
														maxSize={5000000}
                        >
                            <B64Preview
                                source="src"
                                title="title"
                                elStyle={{ width: 100, height: 100 }}
                            />
                        </ImageInput>
                    </Paper>
					{(permissions === 'site_admin') &&
                    <Paper
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: '.5em',
                            padding: '1em'
                        }}
                    >
                        <Labeled label="API Keys">
                            <ReferenceManyField
                                fullWidth
                                reference="user_api_keys"
                                target="user_id"
                                perPage={5}
                                source="id"
                                sort={{ field: "id", order: "DESC" }}
                            >
                                <Datagrid>
                                    <TextField source="nickname" />
                                    <DateField source="date_added" label="Created on" />
                                    <FutureDateField source="date_added" label="Expires on" />
                                    <TextField source="api_key" label="API Key" />
                                    <DeleteButton redirect={false} />
                                </Datagrid>
                            </ReferenceManyField>
                        </Labeled>
                         <APIKeyQuickCreateButton record={record} variant="outlined" />
                    </Paper>
					}
                </div>
			</SimpleForm>
		</Edit>
	);
};

export default UserProfile;
